<template>
  <main class="main main__tickets" role="main">
    <div>
      <section-header>
        <h2 v-html="$t('reservations.title')"/>
<!--        <form class="search">-->
<!--          <input v-model="showName" type="text" name="search_my_tickets" :placeholder="$t('reservations.searchPlaceholder')">-->
<!--          <button @click.prevent="search">{{ $t('reservations.search') }}<i class="fa-solid fa-wand-magic-sparkles"/>-->
<!--          </button>-->
<!--        </form>-->
        <current-past-events-filter
            ref="dateFilter"
            @on-change-filter="(filter) => itemsToShow = filter"
            @click.prevent="fetchReservations"
        />
      </section-header>
      <section-page>
        <div v-if="apiResponse">
          <ul class="list list__tickets">
            <li v-for="(reservation,index) in apiResponse.data" :key="`reservation_${index}`" class="listItem">
              <div class="listItemCol"><img :src="reservation.showFlyer" alt="flyer"></div>
              <div class="listItemCol"><h3>{{ reservation.showName }}</h3>
                <p>
                  <strong>
                    <i class="fa fa-calendar"/>
                    <NuxtTime class="upperCase" :datetime="reservation.date" weekday="long" day="numeric" :locale="language.locale.value"/>
                  </strong>
                  <NuxtTime class="upperCase" :datetime="reservation.date" month="long" year="numeric" :locale="language.locale.value"/>
                </p>
                <p>
                  <strong>
                    <i class="fa fa-clock"/>
                    <NuxtTime class="upperCase" :datetime="reservation.date" hour="numeric" minute="numeric" :hour12="true" :locale="language.locale.value"/>
                  </strong>
                </p>
                <p v-if="reservation.isOnline">
                  <strong>
                    <i class="fa fa-map-marker"/>
                    Virtual
                  </strong>
                </p>
                <p v-else>
                  <strong>
                    <i class="fa fa-map-marker"/>
                    {{ reservation.location?.name }}
                  </strong>
                  {{ reservation.location?.address }}, {{ reservation.location?.city }}.
                </p>
                <p>
                  <strong>
                    <i class="fa fa-ticket"/>
                    {{reservation.showPriceName}}
                  </strong>
                </p>
                <h6>{{ reservation.uuid }}</h6>
              </div>
              <div class="listItemCol">
                <h4>
                  <strong>
                    <i class="fa-solid fa-ticket"/>
                    {{ reservation.ticketQuantity }}
                  </strong> Tickets</h4>
                <NuxtLink class="bt" :to="`/user/reservations/${reservation.uuid}`">{{ $t('reservations.seeTickets') }}</NuxtLink>
                <p>
                  <i class="fa fa-receipt"/>
                  {{ $t('reservations.purchasedAt') }}
                  <strong>
                  <NuxtTime class="upperCase" :datetime="reservation.purchasedDate" month="long" year="numeric" :locale="language.locale.value"/>
                </strong></p>
                <p>{{ $t('reservations.totalAmount') }}<strong>${{ reservation.price }}</strong></p>
              </div>
            </li>
            <li v-if="apiResponse.data.length === 0" class="null">
              <p>
                <center>
                  <i class="fa-solid fa-face-dizzy"/> {{$t('reservations.noTickets')}}
                  <hr>
                  <NuxtLink href="#" to="/" class="bt btG">{{$t('reservations.purchaseTickets')}}</NuxtLink>
                </center>
              </p>
            </li>
          </ul>
          <ul v-if="apiResponse.data.length > 0" class="pager">
            <li v-if="page > 1"><a href="#" @click.prevent="updatePage(1)"><i class="fa fa-angles-left"/></a></li>
            <li v-if="page > 1"><a href="#" @click.prevent="updatePage(apiResponse.current_page - 1)"><i
                class="fa fa-angle-left"/></a></li>
            <li><strong>{{ apiResponse.current_page }}</strong> de {{ apiResponse.last_page }}</li>
            <li v-if="page < apiResponse.last_page">
              <a href="#" @click.prevent="updatePage(apiResponse.current_page + 1)"><i
                  class="fa fa-angle-right"/></a></li>
            <li v-if="page < apiResponse.last_page"><a href="#" @click.prevent="updatePage(apiResponse.last_page)"><i
                class="fa fa-angles-right"/></a></li>
          </ul>
        </div>
      </section-page>
    </div>
  </main>
</template>
<script setup lang="ts">
import CurrentPastEventsFilter from "~/components/buttons/CurrentPastEventsFilter.vue";
import SectionHeader from "~/components/sections/SectionHeader.vue";
import {ref} from 'vue';
import api from "~/api";
import type {ListReservations200Response, ListReservationsItemsToShowEnum} from "~/api/generated";
import SectionPage from "~/components/sections/SectionPage.vue";

definePageMeta({
  layout: 'base-layout',
  middleware: 'auth'
})

const apiResponse = ref<ListReservations200Response | undefined>(undefined)
const showName = ref<string>('')
const itemsToShow = ref<string>('current')
const page = ref(1)
const dateFilter = ref()
const language = useI18n()

async function fetchReservations() {
  const reservationsResponse = await api.Reservation.listReservations(
      showName.value,
      itemsToShow.value as ListReservationsItemsToShowEnum,
      page.value
  )
  apiResponse.value = reservationsResponse.data
}

// function cleanFilters() {
//   showName.value = ''
//   dateFilter.value.setActiveItems(dateFilter.value.all)
//   page.value = 1
//   fetchReservations();
// }

// function search() {
//   page.value = 1
//   fetchReservations()
// }

function updatePage(newPage: number) {
  page.value = newPage
  fetchReservations()
}

fetchReservations()
</script>
<style>
p::first-letter {
  text-transform: capitalize;
}
</style>
